export default __webpack_public_path__ + "static/media/Jack.12ae6c14.png";